/**
 * @generated SignedSource<<372d212ebc6af5ae6ff0c2e933fc4ac9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type layoutHeaderFragment$data = {
  readonly subsections: ReadonlyArray<{
    readonly elements: ReadonlyArray<{
      readonly __typename: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly visualConfig: {
    readonly hidden: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "layoutHeaderFragment";
};
export type layoutHeaderFragment$key = {
  readonly " $data"?: layoutHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"layoutHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "layoutHeaderFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsection",
      "kind": "LinkedField",
      "name": "subsections",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hidden"
        }
      ]
    }
  ],
  "type": "HelpLayoutSection"
};

(node as any).hash = "f703cce131491f9f467281f622f22a23";

export default node;
